import GeoPoint from 'Faster/model/GeoPoint';

interface GeoPointJSON {
  latitude: number;
  longitude: number;
}

class GeoPointJsonTransformer {
  static fromJson(json: GeoPointJSON | string): GeoPoint {
    if (typeof json === 'string') {
      return JSON.parse(json, GeoPointJsonTransformer.reviver);
    }

    const geoPoint = Object.create(GeoPoint.prototype);

    return Object.assign(geoPoint, json);
  }

  static toJsonObject(geoPoint: GeoPoint): object {
    if (typeof geoPoint !== 'object' || null === geoPoint) {
      return null;
    }

    return Object.assign({}, geoPoint);
  }

  static toJson(geoPoint: GeoPoint): string {
    return JSON.stringify(GeoPointJsonTransformer.toJsonObject(geoPoint));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static reviver(key: string, value: any): GeoPoint {
    const isRootLevel = key === '';
    return isRootLevel ? GeoPointJsonTransformer.fromJson(value) : value;
  }
}

export default GeoPointJsonTransformer;
// eslint-disable-next-line no-undef
export { GeoPointJSON };
